import { Input } from "reactstrap"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"

const Notifications = () => {
  const forCustomers = [
    {
      notificationType: "Order Confirmation",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "Shipping Updates",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "Promotional Offers",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "Account Activity",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
  ]
  const forSeller = [
    {
      notificationType: "New Order Recieved",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "inventory low alert",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "payment received",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "account status updates",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
  ]
  const forAdministrators = [
    {
      notificationType: "user registration alerts",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "system error reports",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "sales report",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
    {
      notificationType: "security notifications",
      email: <Input type="checkbox" />,
      sms: <Input type="checkbox" />,
      push: <Input type="checkbox" />,
      inApp: <Input type="checkbox" />,
    },
  ]

  const columns = [
    { name: 'Notification Type', selector: row => row.notificationType },
    { name: 'Email', selector: row => row.email, center: 'true' },
    { name: 'SMS', selector: row => row.sms, center: 'true' },
    { name: 'Push', selector: row => row.push, center: 'true' },
    { name: 'In-App', selector: row => row.inApp, center: 'true' },
  ]

  return (
    <LightGrayBgWrapper>
      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow rounded-top">
        <div className="fw-semibold fs-5">Notification Preferences for customers</div>
        <DynamicButton theme="blue" onClick={() => {}}>
          Notification Type
        </DynamicButton>
      </div>
      <DynamicDatatable data={forCustomers} columns={columns} type='yellow' />
      <div className="mt-3 p-3 d-flex align-items-center justify-content-between bg-white shadow rounded-top">
        <div className="fw-semibold fs-5">Notification Preferences for Seller</div>
        <DynamicButton theme="blue" onClick={() => {}}>
          Notification Type
        </DynamicButton>
      </div>
      <DynamicDatatable data={forSeller} columns={columns} type='yellow' />
      <div className="mt-3 p-3 d-flex align-items-center justify-content-between bg-white shadow rounded-top">
        <div className="fw-semibold fs-5">Notification Preferences for Administrators</div>
        <DynamicButton theme="blue" onClick={() => {}}>
          Notification Type
        </DynamicButton>
      </div>
      <DynamicDatatable data={forAdministrators} columns={columns} type='yellow' />
    </LightGrayBgWrapper>
  )
}

export default Notifications
